/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as PaymentsRouteImport } from './routes/payments'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LocationsRouteImport } from './routes/locations'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FleetIndexRouteImport } from './routes/fleet.index'
import { Route as CustomersIndexRouteImport } from './routes/customers.index'
import { Route as BookingsIndexRouteImport } from './routes/bookings.index'
import { Route as FleetNewRouteImport } from './routes/fleet.new'
import { Route as FleetIdRouteImport } from './routes/fleet.$id'
import { Route as CustomersIdRouteImport } from './routes/customers.$id'
import { Route as BookingsIdRouteImport } from './routes/bookings.$id'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewsRoute = ReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsRoute = PaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationsRoute = LocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const FleetIndexRoute = FleetIndexRouteImport.update({
  id: '/fleet/',
  path: '/fleet/',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersIndexRoute = CustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingsIndexRoute = BookingsIndexRouteImport.update({
  id: '/bookings/',
  path: '/bookings/',
  getParentRoute: () => rootRouteImport,
} as any)
const FleetNewRoute = FleetNewRouteImport.update({
  id: '/fleet/new',
  path: '/fleet/new',
  getParentRoute: () => rootRouteImport,
} as any)
const FleetIdRoute = FleetIdRouteImport.update({
  id: '/fleet/$id',
  path: '/fleet/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersIdRoute = CustomersIdRouteImport.update({
  id: '/customers/$id',
  path: '/customers/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingsIdRoute = BookingsIdRouteImport.update({
  id: '/bookings/$id',
  path: '/bookings/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/dashboard': typeof DashboardRoute
  '/locations': typeof LocationsRoute
  '/login': typeof LoginRoute
  '/payments': typeof PaymentsRoute
  '/reviews': typeof ReviewsRoute
  '/settings': typeof SettingsRoute
  '/bookings/$id': typeof BookingsIdRoute
  '/customers/$id': typeof CustomersIdRoute
  '/fleet/$id': typeof FleetIdRoute
  '/fleet/new': typeof FleetNewRoute
  '/bookings/': typeof BookingsIndexRoute
  '/customers/': typeof CustomersIndexRoute
  '/fleet/': typeof FleetIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/dashboard': typeof DashboardRoute
  '/locations': typeof LocationsRoute
  '/login': typeof LoginRoute
  '/payments': typeof PaymentsRoute
  '/reviews': typeof ReviewsRoute
  '/settings': typeof SettingsRoute
  '/bookings/$id': typeof BookingsIdRoute
  '/customers/$id': typeof CustomersIdRoute
  '/fleet/$id': typeof FleetIdRoute
  '/fleet/new': typeof FleetNewRoute
  '/bookings': typeof BookingsIndexRoute
  '/customers': typeof CustomersIndexRoute
  '/fleet': typeof FleetIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/dashboard': typeof DashboardRoute
  '/locations': typeof LocationsRoute
  '/login': typeof LoginRoute
  '/payments': typeof PaymentsRoute
  '/reviews': typeof ReviewsRoute
  '/settings': typeof SettingsRoute
  '/bookings/$id': typeof BookingsIdRoute
  '/customers/$id': typeof CustomersIdRoute
  '/fleet/$id': typeof FleetIdRoute
  '/fleet/new': typeof FleetNewRoute
  '/bookings/': typeof BookingsIndexRoute
  '/customers/': typeof CustomersIndexRoute
  '/fleet/': typeof FleetIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit'
    | '/dashboard'
    | '/locations'
    | '/login'
    | '/payments'
    | '/reviews'
    | '/settings'
    | '/bookings/$id'
    | '/customers/$id'
    | '/fleet/$id'
    | '/fleet/new'
    | '/bookings/'
    | '/customers/'
    | '/fleet/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit'
    | '/dashboard'
    | '/locations'
    | '/login'
    | '/payments'
    | '/reviews'
    | '/settings'
    | '/bookings/$id'
    | '/customers/$id'
    | '/fleet/$id'
    | '/fleet/new'
    | '/bookings'
    | '/customers'
    | '/fleet'
  id:
    | '__root__'
    | '/'
    | '/audit'
    | '/dashboard'
    | '/locations'
    | '/login'
    | '/payments'
    | '/reviews'
    | '/settings'
    | '/bookings/$id'
    | '/customers/$id'
    | '/fleet/$id'
    | '/fleet/new'
    | '/bookings/'
    | '/customers/'
    | '/fleet/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuditRoute: typeof AuditRoute
  DashboardRoute: typeof DashboardRoute
  LocationsRoute: typeof LocationsRoute
  LoginRoute: typeof LoginRoute
  PaymentsRoute: typeof PaymentsRoute
  ReviewsRoute: typeof ReviewsRoute
  SettingsRoute: typeof SettingsRoute
  BookingsIdRoute: typeof BookingsIdRoute
  CustomersIdRoute: typeof CustomersIdRoute
  FleetIdRoute: typeof FleetIdRoute
  FleetNewRoute: typeof FleetNewRoute
  BookingsIndexRoute: typeof BookingsIndexRoute
  CustomersIndexRoute: typeof CustomersIndexRoute
  FleetIndexRoute: typeof FleetIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reviews': {
      id: '/reviews'
      path: '/reviews'
      fullPath: '/reviews'
      preLoaderRoute: typeof ReviewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments': {
      id: '/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof PaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/locations': {
      id: '/locations'
      path: '/locations'
      fullPath: '/locations'
      preLoaderRoute: typeof LocationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fleet/': {
      id: '/fleet/'
      path: '/fleet'
      fullPath: '/fleet/'
      preLoaderRoute: typeof FleetIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/': {
      id: '/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof CustomersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookings/': {
      id: '/bookings/'
      path: '/bookings'
      fullPath: '/bookings/'
      preLoaderRoute: typeof BookingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fleet/new': {
      id: '/fleet/new'
      path: '/fleet/new'
      fullPath: '/fleet/new'
      preLoaderRoute: typeof FleetNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fleet/$id': {
      id: '/fleet/$id'
      path: '/fleet/$id'
      fullPath: '/fleet/$id'
      preLoaderRoute: typeof FleetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/$id': {
      id: '/customers/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof CustomersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookings/$id': {
      id: '/bookings/$id'
      path: '/bookings/$id'
      fullPath: '/bookings/$id'
      preLoaderRoute: typeof BookingsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuditRoute: AuditRoute,
  DashboardRoute: DashboardRoute,
  LocationsRoute: LocationsRoute,
  LoginRoute: LoginRoute,
  PaymentsRoute: PaymentsRoute,
  ReviewsRoute: ReviewsRoute,
  SettingsRoute: SettingsRoute,
  BookingsIdRoute: BookingsIdRoute,
  CustomersIdRoute: CustomersIdRoute,
  FleetIdRoute: FleetIdRoute,
  FleetNewRoute: FleetNewRoute,
  BookingsIndexRoute: BookingsIndexRoute,
  CustomersIndexRoute: CustomersIndexRoute,
  FleetIndexRoute: FleetIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
